import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const vaccineListApi = async (data) => {
  const endPoint = `admin/vaccine/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
